module.exports = __webpack_public_path__ + "img/123.10744d7c.jpg";